export default {
  common: {
    adminFunction: "Fonction d'administrateur",
    accountManagement: "Gestion de compte",
    accountPermission: "Gestion des comptes et des permissions",
    regionManagement: "Gestion de la région",
    zoneCountryCity: "Mettre à jour zone, pays et ville",
    cityWeatherManagement: "Données météorologiques de la ville",
    weatherProfileBaseOnCity: "Mettre à jour le profil météorologique basé sur la ville",
    ecatDataManagement: "Gestion des données Catalog",
    ecatLibraryEquipmentsModels: "Bibliothèque Catalog équipements et modèles",
    cancel: "Annuler",
    save: "Enregistrer"
  },
  account: {
    inputUserName: "Entrer l'e-mail",
    thereAreNoMoreUsersLeft: "Il n'y a plus d'utilisateurs.",
    superAdmin: "Super Administrateur",
    global: "Mondiale",
    region: "Région",
    regional: "De la région",
    zoneCountry: "Zone/Pays",
    city: "Ville",
    segmentMegaCity: "Segment (Mega ville)",
    status: "Statut",
    activeStatus: "Active status",
    role: "Rôle",
    active: "Actif",
    inactive: "Inactif",
    fillRole: "Veuillez choisir un rôle"
  }
}



// WEBPACK FOOTER //
// ./src/locale/admin/fr.js